<svelte:options
    customElement={{
    tag: "hopper-auction-cinema-v1",
    shadow: "none",
    props: {
      variationId: { type: "String", attribute: "variation-id" },
    },
  }}
/>

<script lang="ts">
  import BasicCinema from "./lib/basic-cinema/BasicCinema.svelte";
  import CinemaHeader from "./lib/cinema-header/CinemaHeader.svelte";
  import {onMount} from "svelte";
  import {fetchCinemaProducts} from "./lib/CinemaService";
  import type {CinemaProps} from "./index";
  import type {CinemaSponsoredProduct} from "./types/CinemaProductsDto.types";
  import DsaSheet from "./lib/dsa-sheet/DsaSheet.svelte";
  import {log} from "../logger.ts";

  const {variationId}: CinemaProps = $props();
  let variations = $state<CinemaSponsoredProduct[]>([]);
  let auctionId = $state("");
  let cinemaTrackingLabels = $state<Record<string, string[]>>({});
  let dsaSheet: DsaSheet | undefined = $state();
  let allProductTilesFailed = $state(false);

  onMount(async () => {
    if (!variationId) {
      log.error("Cinema: variationId is required");
      return;
    }

    const [err, res] = await fetchCinemaProducts(variationId);

    if (err) {
      log.error("Error fetching cinema products:", err);
      return;
    }

    variations = res.cinemaSponsoredProducts ?? [];
    auctionId = res.auctionId ?? "";
    cinemaTrackingLabels = res.cinemaTrackingLabels ?? {};
  });

  function openDsaSheet() {
    dsaSheet?.open();
  }
</script>

<div class="spa-cinema">
  {#if variations.length > 0 && !allProductTilesFailed}
    <div class="cinema-container">
      <CinemaHeader {variations} onDsaClick={openDsaSheet}/>
      <BasicCinema
          {variations}
          {auctionId}
          {cinemaTrackingLabels}
          onAllProductTilesFailed={() => (allProductTilesFailed = true)}
      />
    </div>

    <DsaSheet bind:this={dsaSheet} {variations}/>
  {/if}
</div>

<style lang="scss">
  @use '@otto-ec/design-tokens/tokens';

  .cinema-container {
    display: flex;
    flex-direction: column;
    margin-bottom: tokens.$oc-semantic-spacing-150;
    container-type: inline-size;
  }
</style>
